import mod from "-!../../../../../../../node_modules/babel-loader/lib/index.js??ref--4!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RadioGroup.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../../../node_modules/babel-loader/lib/index.js??ref--4!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RadioGroup.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/RadioGroup.vue?vue&type=script&lang=js&
// module id = 411
// module chunks = 0